// @ts-nocheck
import { IconOffset } from "@toolkit/Framework/Types/Icon";
import * as React from "react";

const AlertCircleLine: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M12 20c4.416 0 8-3.584 8-8s-3.584-8-8-8-8 3.584-8 8 3.584 8 8 8Zm0-12c.44 0 .8.36.8.8V12c0 .44-.36.8-.8.8s-.8-.36-.8-.8V8.8c0-.44.36-.8.8-.8Zm-.8 6.4h1.6V16h-1.6v-1.6Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export const AlertCircleLineOffset: IconOffset = {
    vertical: 16, // Store Custom Code
    horizontal: 16, // Store Custom Code
};

export default React.memo(AlertCircleLine);
